import { useMemo } from 'react'
import { useVersioning } from 'modules/versioning'
import { NavigationStackNode } from './types'

/**
 * Create a link to the view corresponding to the provided navigation stack node.
 * @return the URL to the view.
 */
export function useShareViewNavigationNodeLink(
  navigationStackNode: NavigationStackNode | undefined
) {
  const { share, getPathname } = useVersioning()

  return useMemo(() => {
    if (!navigationStackNode) {
      return getPathname({
        routeKey: 'SHARE_VIEW',
        routeParams: { shareID: share.identifier },
      })
    }

    if (navigationStackNode.view === 'canvas') {
      return getPathname({
        routeKey: 'SHARE_PAGE_CANVAS_VIEW',
        routeParams: {
          shareID: share.identifier,
          pageUUID: navigationStackNode.pageUUID,
        },
      })
    }

    if (navigationStackNode.view === 'page') {
      return getPathname({
        routeKey: 'SHARE_PAGE_VIEW',
        routeParams: {
          shareID: share.identifier,
          pageUUID: navigationStackNode.pageUUID,
        },
      })
    }

    return getPathname({
      routeKey: 'SHARE_VIEW',
      routeParams: { shareID: share.identifier },
    })
  }, [getPathname, navigationStackNode, share.identifier])
}
